/** Accent colour for the in-progress path's anchors, handles and close-path ring. */
export const PEN_ACCENT_COLOR = '#0284C7'
